import { Link } from "react-router-dom";

const LINKS = [
  { to: "/terms", label: "Terms" },
  { to: "/privacy", label: "Privacy" },
  { to: "/refund-policy", label: "Refund Policy" },
  { to: "/cookies", label: "Cookies" },
];

interface LegalFooterProps {
  className?: string;
  compact?: boolean;
}

/**
 * Lightweight legal link row. Display-only — no logic.
 * Used in AppLayout (logged-in), Login (public), and legal pages.
 */
export function LegalFooter({ className, compact = false }: LegalFooterProps) {
  return (
    <footer
      className={
        "border-t border-border/30 bg-background/60 " +
        (compact ? "px-3 py-2" : "px-5 py-4") +
        (className ? ` ${className}` : "")
      }
    >
      <div className="max-w-3xl mx-auto flex flex-wrap items-center justify-center gap-x-4 gap-y-1.5 text-[11px] text-muted-foreground">
        <span className="text-muted-foreground/70">
          © {new Date().getFullYear()} Seatech Aquarium Intelligence
        </span>
        {LINKS.map((l) => (
          <Link
            key={l.to}
            to={l.to}
            className="hover:text-foreground transition-colors underline-offset-2 hover:underline"
          >
            {l.label}
          </Link>
        ))}
      </div>
    </footer>
  );
}